export function maskPhoneNumber(phoneNumber: string): string {
  const cleanedNumber = phoneNumber.replace(/\D/g, ''); // Remove non-numeric characters
  const maskedPhoneNumber = cleanedNumber.replace(/(\d{0,1})(\d{10})/, (_, codePart: string, phonePart: string) => {
    let maskedNumber = '';
    if (codePart) maskedNumber += `${codePart}-`;
    if (phonePart)
      maskedNumber += phonePart.replace(
        /(\d{0,3})(\d{0,3})(\d{0,4})/,
        (_, part1: string, part2: string, part3: string) => {
          let masked = '';
          if (part1) masked += `${part1}`;
          if (part2) masked += `-${part2}`;
          if (part3) masked += `-${part3}`;
          return masked;
        },
      );
    return maskedNumber;
  });
  return maskedPhoneNumber;
}

export function maskDate(date: string): string {
  const cleanedDate = date.replace(/[^0-9/]/g, '');
  const maskedDate = cleanedDate.replace(
    /(\d{0,2})(\/?)(\d{0,2})(\/?)(\d{0,4})/,
    (_, part1: string, slash1: string, part2: string, slash2: string, part3: string) => {
      let masked = '';

      if (part1) {
        if (part1.length === 1 && slash1 === '/') {
          masked += `0${part1}/`;
        } else {
          masked += part1;
        }
      }

      if (part2) {
        if (part2.length === 1 && slash2 === '/') {
          masked += `/0${part2}/`;
        } else {
          masked += `/${part2}`;
        }
      }

      if (part3) masked += `/${part3}`;

      return masked;
    },
  );
  return maskedDate;
}

export function maskNumber(number: string | number): string {
  const removeNonNumeric = number.toString().replace(/[^0-9]/g, '');
  const maskedNumber = removeNonNumeric.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  return maskedNumber;
}
